import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const phoenixConfig: TSPConfig = {
  key: 'phoenix',
  name: 'Phoenix',
  category: TSPCategory.CUSTOM,
  helpText:
    "Please input the company ID from your Phoenix profile. Include the word 'Company:', if provided.",
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Company ID', name: 'company', type: 'text', required: true },
      ]}
    />
  ),
};

export default phoenixConfig;
